import script from "./LadiesFashion.vue?vue&type=script&setup=true&lang=js"
export * from "./LadiesFashion.vue?vue&type=script&setup=true&lang=js"

import "./LadiesFashion.vue?vue&type=style&index=0&id=58eca0a7&lang=css"

const __exports__ = script;

export default __exports__